export default "__VITE_ASSET__CST0f3Z1__"